import { ListSubheader } from '@mui/material';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import { orderBy, uniqBy } from 'lodash';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import Iconify from 'src/components/iconify';

const RowAction = ({ row, isSuperAdmin, hideDelete, onEdit, onDelete }) => {
  const popover = usePopover();

  const userOrganizations = orderBy(
    uniqBy(
      row?.users_user_organizations,
      (item) => item?.user_organizations_organization?.organization_id,
      row
    ),
    (item) => item?.user_organizations_organization?.name
  );

  return (
    <>
      <IconButton color={popover.open ? 'primary' : 'default'} onClick={popover.onOpen}>
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>
      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ minWidth: 160, maxHeight: 400, overflow: 'auto' }}
      >
        {isSuperAdmin ? (
          <>
            <ListSubheader disableSticky>Edit user for:</ListSubheader>
            <Divider sx={{ borderStyle: 'dashed' }} />
            {userOrganizations?.map((userOrg) => {
              return (
                <MenuItem
                  key={userOrg?.user_organizations_organization?.organization_id}
                  onClick={() => {
                    onEdit(userOrg?.user_organizations_organization?.organization_id);
                    popover.onClose();
                  }}
                >
                  <Iconify icon="solar:pen-bold" />
                  {userOrg?.user_organizations_organization?.name}
                </MenuItem>
              );
            })}
          </>
        ) : (
          <>
            <MenuItem
              onClick={() => {
                onEdit();
                popover.onClose();
              }}
            >
              <Iconify icon="solar:pen-bold" />
              Edit
            </MenuItem>
          </>
        )}

        <Divider sx={{ borderStyle: 'dashed' }} />
        <MenuItem
          disabled={hideDelete}
          onClick={() => {
            onDelete();
            popover.onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          Delete
        </MenuItem>
      </CustomPopover>
    </>
  );
};

export default RowAction;
